import { CFC } from "types/commonExtend/CFC";

export const createComponent = <Props extends {}>(name: string, Component: CFC<Props>): CFC<Props> => {
  // @ts-ignore
  Component.displayName = name;
  return Component;
};
